import SiteLayout from "@/components/feature/SiteLayout";
import { allMedia, allNews } from "@/utils/data";
import { sortItems, MEDIA_TYPES } from "@/utils/media";
import HeroCarousel from "./components/HeroCarousel";
import CategoryQuickLinks from "./components/CategoryQuickLinks";
import LatestResources from "./components/LatestResources";
import HotRanking from "./components/HotRanking";
import NewsPreview from "./components/NewsPreview";
import IntroStats from "./components/IntroStats";

export default function Home() {
  const heroItems = sortItems(allMedia, "最热").slice(0, 5);
  const latest = sortItems(allMedia, "最新更新").slice(0, 12);
  const hot = sortItems(allMedia, "最热").slice(0, 8);
  const news = allNews.slice(0, 3);

  const counts = MEDIA_TYPES.reduce<Record<string, number>>((acc, type) => {
    acc[type] = allMedia.filter((item) => item.type === type).length;
    return acc;
  }, {});

  return (
    <SiteLayout>
      <h1 className="sr-only">水母影视</h1>

      <HeroCarousel items={heroItems} />

      <section className="px-4 md:px-6 py-10 md:py-14">
        <CategoryQuickLinks counts={counts} />
      </section>

      <section className="bg-background-100">
        <div className="px-4 md:px-6 py-10 md:py-14">
          <LatestResources items={latest} />
        </div>
      </section>

      <section className="px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8 items-start">
          <div className="lg:col-span-2">
            <HotRanking items={hot} />
          </div>
          <IntroStats />
        </div>
      </section>

      <section className="bg-background-100">
        <div className="px-4 md:px-6 py-10 md:py-14">
          <NewsPreview items={news} />
        </div>
      </section>
    </SiteLayout>
  );
}